module.exports = __webpack_public_path__ + "static/media/Action.net.b3c36286.svg";